export const addSuffix = (number?: number): string => {
  if (!number) return '';
  const stringNum = number.toString();
  const lastNum = stringNum.charAt(stringNum.length - 1);
  let suffix = 'th';
  if (lastNum === '1' && stringNum !== '11') suffix = 'st';
  else if (lastNum === '2' && stringNum !== '12') suffix = 'nd';
  else if (lastNum === '3' && stringNum !== '13') suffix = 'rd';
  return `${number}${suffix}`;
};
